"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Stepper", {
    enumerable: true,
    get: function() {
        return Stepper;
    }
});
var _react = require("@chakra-ui/react");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var $size = (0, _react.cssVar)("stepper-indicator-size");
var $iconSize = (0, _react.cssVar)("stepper-icon-size");
var $accentColor = (0, _react.cssVar)("stepper-accent-color");
var $primaryDefaultColor = (0, _react.cssVar)("chakra-colors-primary-default");
var _obj;
var Stepper = {
    parts: [
        "stepper",
        "step",
        "title",
        "description",
        "indicator",
        "separator",
        "icon",
        "number"
    ],
    baseStyle: {
        stepper: _define_property({
            display: "flex",
            gap: 0
        }, $accentColor.variable, $primaryDefaultColor.reference),
        step: {
            gap: 0
        },
        indicator: {
            "&[data-status=incomplete]": {
                borderColor: "background-static"
            }
        },
        separator: {
            "&[data-status=active]": {
                bg: "background-static"
            },
            "&[data-status=incomplete]": {
                bg: "background-static"
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: 0
            }
        }
    },
    sizes: {
        s: {
            stepper: (_obj = {}, _define_property(_obj, $size.variable, "1.25rem"), _define_property(_obj, $iconSize.variable, "0.75rem"), _obj)
        }
    },
    defaultProps: {
        size: "s",
        variant: "horizontal"
    }
};
